/* ============================================================
   L'ESPRIT COCON — Kit premium interactions
   Pure Vanilla JS, ~4KB, respecte prefers-reduced-motion
   ============================================================ */
(function() {
  'use strict';

  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reduced) return;

  /* ------------------------------------------------------------
     1. SCROLL REVEAL — sections apparaissent au scroll
     ------------------------------------------------------------ */
  const revealObserver = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('lec-in-view');
        revealObserver.unobserve(entry.target);
      }
    });
  }, { threshold: 0.08, rootMargin: '0px 0px -80px 0px' });

  function initReveal() {
    const targets = document.querySelectorAll(
      '.shopify-section, .card-wrapper, .banner__content, ' +
      '.multicolumn-card, .rich-text__blocks, .quote, ' +
      '.collection-hero__text-wrapper, .product__info-wrapper'
    );
    targets.forEach((el, i) => {
      el.classList.add('lec-reveal');
      // décale légèrement en fonction de la position dans le parent
      el.style.setProperty('--lec-reveal-delay', `${Math.min(i * 40, 200)}ms`);
      revealObserver.observe(el);
    });
  }

  /* ------------------------------------------------------------
     2. SPLIT TEXT — h1/h2 lettre par lettre au reveal
     ------------------------------------------------------------ */
  function splitHeadings() {
    const headings = document.querySelectorAll(
      '.banner__heading, .rich-text__heading, .h0, ' +
      '.section-header__title, .collection-hero__title'
    );
    headings.forEach(h => {
      if (h.dataset.lecSplit) return;
      const text = h.textContent.trim();
      if (text.length > 90) return; // pas sur textes longs
      h.dataset.lecSplit = '1';
      h.innerHTML = text.split(' ').map(word =>
        `<span class="lec-word">${
          word.split('').map((c, i) =>
            `<span class="lec-char" style="--lec-char-i:${i}">${c}</span>`
          ).join('')
        }</span>`
      ).join(' ');
      h.classList.add('lec-split');
    });
  }

  /* ------------------------------------------------------------
     3. (CURSOR MAGNÉTIQUE retiré — le natif est plus lisible)
     ------------------------------------------------------------ */

  /* ------------------------------------------------------------
     4. PARALLAX subtle sur images hero + media
     ------------------------------------------------------------ */
  function initParallax() {
    const media = document.querySelectorAll(
      '.banner__media img, .image-banner img, .rich-text__blocks + .media img'
    );
    if (!media.length) return;

    let ticking = false;
    function update() {
      const scroll = window.scrollY;
      media.forEach(img => {
        const rect = img.getBoundingClientRect();
        if (rect.bottom < 0 || rect.top > window.innerHeight) return;
        const speed = 0.08;
        const yOffset = (window.innerHeight/2 - rect.top - rect.height/2) * speed;
        img.style.transform = `translate3d(0, ${yOffset}px, 0) scale(1.06)`;
      });
      ticking = false;
    }
    window.addEventListener('scroll', () => {
      if (!ticking) {
        requestAnimationFrame(update);
        ticking = true;
      }
    }, { passive: true });
    update();
  }

  /* ------------------------------------------------------------
     5. HEADER SCROLL STATE — plus dense au scroll
     ------------------------------------------------------------ */
  function initHeaderScroll() {
    const header = document.querySelector('.header-wrapper');
    if (!header) return;
    let lastY = 0;
    window.addEventListener('scroll', () => {
      const y = window.scrollY;
      header.classList.toggle('lec-header-scrolled', y > 60);
      header.classList.toggle('lec-header-hidden', y > lastY && y > 240);
      lastY = y;
    }, { passive: true });
  }

  /* ------------------------------------------------------------
     5b. HEADER TRANSPARENT (façon Baobab) — uniquement quand la
     page commence par un banner image : le hero glisse sous le
     header, qui reste transparent tant qu'on n'a pas scrollé.
     ------------------------------------------------------------ */
  function initTransparentHeader() {
    const header = document.querySelector('.header-wrapper');
    const main = document.getElementById('MainContent');
    if (!header || !main) return;
    const first = main.querySelector('.shopify-section');
    if (!first || !first.querySelector('.banner')) return; // seulement pages avec hero
    document.documentElement.classList.add('lec-transparent-header');
    // Le hero remonte sous TOUT le groupe header (annonce + header),
    // recalculé précisément pour éviter toute bande blanche.
    const apply = () => {
      main.style.marginTop = '';
      const top = main.getBoundingClientRect().top + window.scrollY;
      main.style.marginTop = `-${Math.ceil(top)}px`;
    };
    apply();
    window.addEventListener('load', apply);
    window.addEventListener('resize', apply, { passive: true });
    if (window.ResizeObserver) {
      const ro = new ResizeObserver(apply);
      ro.observe(header);
      const ann = document.querySelector('.announcement-bar-section');
      if (ann) ro.observe(ann);
    }
  }

  /* ------------------------------------------------------------
     6. MAGNETIC BUTTONS — boutons qui attirent le curseur
     ------------------------------------------------------------ */
  function initMagneticButtons() {
    const buttons = document.querySelectorAll('.button, .shopify-payment-button__button');
    buttons.forEach(btn => {
      btn.addEventListener('mousemove', (e) => {
        const rect = btn.getBoundingClientRect();
        const x = e.clientX - rect.left - rect.width / 2;
        const y = e.clientY - rect.top - rect.height / 2;
        btn.style.transform = `translate(${x * 0.15}px, ${y * 0.15}px)`;
      });
      btn.addEventListener('mouseleave', () => {
        btn.style.transform = '';
      });
    });
  }

  /* ------------------------------------------------------------
     7. IMAGE ZOOM SUR CARDS PRODUITS AU HOVER
     Ajout d'un léger halo doré animé
     ------------------------------------------------------------ */
  function initCardHalo() {
    const cards = document.querySelectorAll('.card-wrapper, .card');
    cards.forEach(card => {
      card.addEventListener('mousemove', (e) => {
        const rect = card.getBoundingClientRect();
        const x = ((e.clientX - rect.left) / rect.width) * 100;
        const y = ((e.clientY - rect.top) / rect.height) * 100;
        card.style.setProperty('--lec-halo-x', x + '%');
        card.style.setProperty('--lec-halo-y', y + '%');
      });
    });
  }

  /* ------------------------------------------------------------
     8. SMOOTH ANCHOR SCROLL
     ------------------------------------------------------------ */
  function initSmoothAnchor() {
    document.addEventListener('click', (e) => {
      const link = e.target.closest('a[href^="#"]');
      if (!link) return;
      const target = document.querySelector(link.getAttribute('href'));
      if (!target) return;
      e.preventDefault();
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  }


  /* ------------------------------------------------------------
     9. STICKY ADD-TO-CART (fiche produit) — apparaît quand le
     bouton principal sort du viewport
     ------------------------------------------------------------ */
  function initStickyATC() {
    const form = document.querySelector('form[id^="product-form-"]');
    const submitBtn = document.querySelector('.product-form__submit');
    const titleEl = document.querySelector('.product__title h1, .product__title');
    if (!form || !submitBtn || !titleEl) return;

    const priceEl = document.querySelector('.price__regular .price-item, .price-item');

    const bar = document.createElement('div');
    bar.className = 'lec-sticky-atc';
    bar.innerHTML = `
      <div class="lec-sticky-atc__info">
        <span class="lec-sticky-atc__title">${titleEl.textContent.trim()}</span>
        <span class="lec-sticky-atc__price">${priceEl ? priceEl.textContent.trim() : ''}</span>
      </div>
      <button type="button" class="lec-sticky-atc__btn">Ajouter au panier</button>
    `;
    document.body.appendChild(bar);

    bar.querySelector('.lec-sticky-atc__btn').addEventListener('click', () => {
      submitBtn.click();
    });

    // maj prix quand la variante change : le thème recharge le bloc prix
    // de façon asynchrone, on suit donc le bloc lui-même (pas l'événement change)
    const priceWrap = document.querySelector('[id^="price-"][role="status"]');
    const syncPrice = () => {
      const root = priceWrap || document;
      const p = root.querySelector('.price--on-sale')
        ? root.querySelector('.price-item--sale')
        : root.querySelector('.price__regular .price-item, .price-item');
      if (p) bar.querySelector('.lec-sticky-atc__price').textContent = p.textContent.trim();
    };
    if (priceWrap) {
      new MutationObserver(syncPrice).observe(priceWrap, { childList: true, subtree: true, characterData: true });
    }
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.variantChange, () => requestAnimationFrame(syncPrice));
    }
    document.addEventListener('change', () => setTimeout(syncPrice, 400), true);

    const io = new IntersectionObserver((entries) => {
      entries.forEach(e => {
        bar.classList.toggle('lec-sticky-atc--visible', !e.isIntersecting && e.boundingClientRect.top < 0);
      });
    }, { threshold: 0 });
    io.observe(submitBtn);
  }

  /* ------------------------------------------------------------
     Init
     ------------------------------------------------------------ */
  function init() {
    initReveal();
    splitHeadings();
    initParallax();
    initHeaderScroll();
    initTransparentHeader();
    initMagneticButtons();
    initCardHalo();
    initSmoothAnchor();
    initStickyATC();
    document.documentElement.classList.add('lec-premium-ready');
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
